import { useQuery } from '@tanstack/react-query';

import { UserKey } from './keys';
import { UserService } from './userService';

export function useGetUserGroups(id?: number, enabled = true) {
  return useQuery({
    queryKey: [UserKey.USER_GROUPS, id],
    queryFn: () => UserService.getUserGroup(id).then((response) => response.data),
    enabled: enabled && !!id,
  });
}
